import React, { ReactNode } from "react"

const Card = ({ children }) => {
  return (
    <div className="d-flex justify-content-center">
      <div className="card flex-grow-1" style={{ maxWidth: 640 }}>
        <div className="card-body">{children}</div>
      </div>
    </div>
  )
}
export default Card

export const SmallCard = ({ children }) => {
  return (
    <div className="container-fluid">
      <div className="row justify-content-center m-2">
        <div className="card col-12 col-md-6 col-lg-4">
          <div className="card-body">{children}</div>
        </div>
      </div>
    </div>
  )
}

export const MediumCard = ({ children }) => {
  return (
    <div className="container-fluid">
      <div className="row justify-content-center m-2">
        <div className="card col-12 col-md-8 col-lg-6">
          <div className="card-body">
            <div className="d-flex flex-column gap-3">{children}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const LargeCard = ({ children }: { children: ReactNode }) => {
  return (
    <div className="container-fluid">
      <div className="row justify-content-center m-2">
        <div className="card col-12 col-md-12 col-lg-10">
          <div className="card-body">{children}</div>
        </div>
      </div>
    </div>
  )
}

export const FullWidthCard = ({ children }) => {
  return (
    <div className="container-fluid">
      <div className="row justify-content-center m-2">
        <div className="card col-12 col-md-12 col-lg-12">
          <div className="card-body">{children}</div>
        </div>
      </div>
    </div>
  )
}
